import { transform } from '../../../lib/transform';
import { IImageProductProperties } from './i-image-product-properties';
import { TagManagerProductDto } from './tag-manager-product.dto';

export function buildImageProduct(properties: IImageProductProperties): TagManagerProductDto {
  const orderedWidth = properties.orderedWidth || properties.width;
  const orderedHeight = properties.orderedHeight || properties.height;

  return transform(TagManagerProductDto, {
    brand: properties.category,
    category: properties.area,
    id: properties.name,
    name: properties.productName,
    variant: properties.section,
    dimension5: properties.assetType,
    dimension9: properties.producedFor,
    dimension13: orderedWidth - properties.width,
    dimension14: orderedHeight - properties.height,
  });
}
